const getOrderLineDiagnosis = ({ orderLine, value, index }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  if (index !== undefined) {
    const indexOrderLine = orderLine ? orderLine[index] : null;
    if (indexOrderLine) {
      return indexOrderLine['Primary Diagnosis']
        ? indexOrderLine['Primary Diagnosis'][0]['DX Code']
        : indexOrderLine.Diagnosis['DX Code'];
    }
    return null;
  }
  return orderLine
    ? orderLine.map(item => item['Primary Diagnosis'][0]['DX Code']).join(', ')
    : null;
};

export default getOrderLineDiagnosis;



// WEBPACK FOOTER //
// ./src/utils/print/getOrderLineDiagnosis.js